import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowRight } from "@phosphor-icons/react";

export default function Countries() {
  const [countries, setCountries] = useState([]);
  useEffect(() => { api.get("/countries").then((r) => setCountries(r.data)); }, []);

  return (
    <div data-testid="countries-page" className="fade-in py-20">
      <div className="container-gos">
        <div className="overline mb-3">Choose a market</div>
        <h1 className="font-display text-4xl sm:text-5xl text-gos-charcoal tracking-tight">Where would you like to grow?</h1>
        <p className="text-gos-slate max-w-2xl mt-4 leading-relaxed">
          Select a country to see local pricing, services, tax rates, setup timelines and case studies. New countries are added regularly through our admin panel.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {countries.map((c) => (
            <Link
              key={c.slug}
              to={`/countries/${c.slug}`}
              data-testid={`country-card-${c.slug}`}
              className="card-lift bg-white border border-gos-border rounded-sm overflow-hidden"
            >
              {c.tile_image_url && (
                <div className="aspect-[16/10] overflow-hidden bg-gos-subtle">
                  <img src={c.tile_image_url} alt={c.name} className="w-full h-full object-cover" />
                </div>
              )}
              <div className="p-6">
                <div className="flex items-center gap-3">
                  <span className="text-3xl">{c.flag}</span>
                  <div>
                    <div className="font-display text-2xl text-gos-navy leading-none">{c.name}</div>
                    <div className="overline mt-1">{c.tagline || c.currency_code}</div>
                  </div>
                </div>
                <p className="text-sm text-gos-slate mt-4 leading-relaxed">{c.short_description}</p>
                <div className="grid grid-cols-3 gap-3 mt-5 text-xs font-mono">
                  <div><div className="text-gos-muted">Corp tax</div><div className="text-gos-charcoal font-medium">{c.corporate_tax_rate}%</div></div>
                  <div><div className="text-gos-muted">Setup</div><div className="text-gos-charcoal font-medium">{c.setup_timeline_days}d</div></div>
                  <div><div className="text-gos-muted">Rating</div><div className="text-gos-charcoal font-medium">{c.overall_rating}/10</div></div>
                </div>
                <div className="mt-5 inline-flex items-center gap-1 text-sm text-gos-navy">Explore {c.name} <ArrowRight size={14} weight="bold" /></div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
